import {
  CHECK_CRBS_CONFIGURED_FAILED,
  CHECK_CRBS_CONFIGURED_START,
  CHECK_CRBS_CONFIGURED_SUCCESS,
  NOTIFICATION_CLEAR,
  NOTIFICATION_CREATE,
  NOTIFICATION_REMOVE} from "./constants";

const statusReducer = (state = { loading: false }, action) => {
  switch (action.type) {
    case CHECK_CRBS_CONFIGURED_START:
      return {
        ...state,
        loading: true
      };
    case CHECK_CRBS_CONFIGURED_SUCCESS:
      return {
        ...state,
        ...action.status,
        loading: false
      };
    case CHECK_CRBS_CONFIGURED_FAILED:
      return {
        ...state,
        errorDescription: action.error.description,
        error: action.error.message,
        loggedIn: false,
        loading: false
      };
    default:
      return state;
  }
};

const notificationsReducer = (state = { items: [] }, action) => {
  // Create an error notification for any arbitrary FAILED action
  if (action.type && action.type.endsWith("FAILED")) {
    return {
      items: [...state.items, { ...action.error, type: "error" }]
    };
  }

  switch (action.type) {
    case NOTIFICATION_CREATE:
      return {
        items: [
          ...state.items,
          { ...action.notification, type: "notification" }
        ]
      };
    case NOTIFICATION_REMOVE:
      return {
        items: state.items.filter(item => item.id !== action.id)
      };
    case NOTIFICATION_CLEAR:
      return {
        items: []
      };
    default:
      return state;
  }
};

export { statusReducer, notificationsReducer };
